/**
 * Bigscreen Remote 頁面配置
 *
 * 定義所有 bigscreen 模組的頁面，自動生成：
 * - vite.config exposes
 * - remoteModules
 * - pagePermissions
 * - sideNavMenus
 */

import type { RemoteModuleConfig, PageConfig } from './types';

// ============================================================================
// 頁面配置
// ============================================================================

export const pages: PageConfig[] = [
    // 主要頁面
    {
        name: 'VisualizationScreen',
        path: './views/VisualizationScreen.vue',
        title: '大屏列表',
        mode: 'bigscreen',
        icon: 'icofont-monitor',
        default: true,
        showInSideNav: true,
        standalone: { show: true, group: '主要功能', order: 1 },
    },
    {
        name: 'Dashboard',
        path: './views/Dashboard.vue',
        title: '儀表板大屏',
        mode: 'bigscreen',
        default: true,
        standalone: { show: true, group: '主要功能', order: 2 },
    },
    {
        name: 'EquipmentOverview',
        path: './views/EquipmentOverview.vue',
        title: '設備總覽大屏',
        mode: 'bigscreen',
        default: true,
        standalone: { show: true, group: '主要功能', order: 3 },
    },
    {
        name: 'Settings',
        path: './views/Settings.vue',
        title: '大屏設定',
        mode: 'bigscreen',
        icon: 'icofont-ui-settings',
        default: true,
        showInSideNav: true,
    },
    // 特定場域大屏
    {
        name: 'HengYuan',
        path: './views/HengYuan.vue',
        title: '恆源大屏',
        mode: 'bigscreen',
        default: false,
        standalone: { show: true, group: '場域大屏', order: 1 },
    },
    {
        name: 'Lioho',
        path: './views/Lioho.vue',
        title: '六和大屏',
        mode: 'bigscreen',
        default: false,
        standalone: { show: true, group: '場域大屏', order: 2 },
    },
    {
        name: 'Med',
        path: './views/Med.vue',
        title: '醫療大屏',
        mode: 'bigscreen',
        default: false,
        standalone: { show: true, group: '場域大屏', order: 3 },
    },
    {
        name: 'LNG',
        path: './views/LNG.vue',
        title: 'LNG 大屏',
        mode: 'bigscreen',
        default: false,
        standalone: { show: true, group: '場域大屏', order: 4 },
    },
    {
        name: 'Hexin3D',
        path: './views/Hexin3D.vue',
        title: '核心智慧畜牧園區 3D',
        mode: 'bigscreen',
        default: false,
        standalone: { show: true, group: '場域大屏', order: 5 },
    },
    // 功能頁面
    {
        name: 'PowerDispatchSimulator',
        path: './views/PowerDispatchSimulator.vue',
        title: '電力調度模擬',
        mode: 'bigscreen',
        default: false,
        standalone: { show: true, group: '工具', order: 1 },
    },
    {
        name: 'GeneratorOutage',
        path: './views/GeneratorOutage.vue',
        title: '發電機歷史 / 停機資料導出',
        mode: 'bigscreen',
        default: false,
        standalone: { show: true, group: '工具', order: 2 },
    },
];

// ============================================================================
// 模組完整配置
// ============================================================================

export const config: RemoteModuleConfig = {
    name: 'bigscreen',
    federationName: 'bigscreen_remote',
    port: 7005,
    pages,
};

export default config;
